/**
 *
 * Asynchronously loads the component for HiringDashboard
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/HiringDashboard/loadable.js